import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ButtonClean = styled.button`
  background: none;
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  border: none;
  width: 55px;
  height: 25px;
  &:hover {
    text-decoration: underline;
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonFilter = styled.button`
  background: none;
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 5px;
  width: 55px;
  height: 25px;
  &:hover {
    text-decoration: underline;
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ContentFilters = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 54px;
  max-width: 120px;
`;

export const FieldsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin: 0px 2%;
  width: 96%;
  flex-wrap: wrap;
  input::placeholder {
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.neutral.gray[2600]};
  }
  input {
    font-size: 13px;
  }
`;

export const FieldHeader = styled.div`
  margin: 10px 0;
  label {
    font-weight: 600;
  }
  svg {
    float: right;
  }
`;

export const ExpandedContainer = styled.div`
  // visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  // height: ${({ isVisible }) => (isVisible ? "auto" : "0")};
  // margin-bottom: ${({ isVisible }) => (isVisible ? "1rem" : "0")};
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  div {
    width: 100%;
  }
  label {
    color: ${({ theme }) => theme.neutral.gray[2200]};
    font-size: 12px;
    width: 90%;
    margin-left: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input {
    width: 100%;
    font-size: 13px;
  }
  input::placeholder {
    font-size: 13px;
  }
`;

export const FieldContainer = styled.div`
  width: 100%;
  max-width: 130px;
  margin: 0 10px;
`;
export const DateContainer = styled.div`
  display: flex;
  margin: 0 10px;
  input {
    margin: 0 10px;
  }
`;
